<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../../components/SearchHeader.svelte";
  import { Table } from "../../../components/Table";
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import { filter, loading, records, pagination, initList, onCreate, onEdit, onDelete, onPageChange, search } from "./quality-incident.store";
  import { qualityIncidentDtoFields } from "../../../utils/TableFields/quality-incident-dto.fields";

  onMount(initList);
</script>

<QualityLayout>
  <SearchHeader
    entitySingular="Non Conformità"
    entityPlural="Non Conformità"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  ></SearchHeader>

  <Table
    loading={$loading}
    fields={qualityIncidentDtoFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</QualityLayout>
